import type { FieldValues } from 'react-hook-form';

import { formatPhone, PHONE_DISPLAY_MAX_LENGTH } from '../../utils/inputMasks';
import { TextField, type TextFieldProps } from '../TextField';

/**
 * A phone-number TextField: the `(xxx) xxx-xxxx` mask + the mobile keyboard /
 * autofill hints baked in, so every consumer formats and behaves identically.
 * Supports both modes TextField does — react-hook-form (`control` + `name`) and
 * controlled (`value` + `onChangeText` + `errorMessage`).
 *
 * Validation lives with the consumer (a Zod `isValidPhoneDisplay` refine on a
 * form schema, or a manual check before submit) — import `isValidPhoneDisplay`
 * from `@/modules/ui` for the matching rule. This component only owns input
 * shaping, not the valid/invalid decision.
 */
export function PhoneField<TFieldValues extends FieldValues>(props: TextFieldProps<TFieldValues>) {
  return (
    // Phone shaping is owned by this component — its props go last so a consumer
    // can't accidentally override the mask, length cap, or keyboard hints; the
    // consumer still supplies label/placeholder/testID and the control binding.
    <TextField
      {...props}
      autoComplete='tel'
      inputMode='tel'
      keyboardType='phone-pad'
      textContentType='telephoneNumber'
      maxLength={PHONE_DISPLAY_MAX_LENGTH}
      format={formatPhone}
    />
  );
}
